/**
 * Base state for current module
 */
const state = {
  events: [],
  props: {
    limit: 10,
  },
  propOptions: {},
  largestQuerySize: 0,
  defaultProps: [
    {
      key: 'limit',
      label: "Limit",
      helperText: "Select the number of items to view (max 30)",
      type: "text",
      value: 10,
      validation: "required:true|between:1,30",
    }
  ],
  status: 'WAITING'
};

export default state;
